module.exports = __webpack_public_path__ + "img/s1.4fbdc9ea.png";